module.exports = __webpack_public_path__ + "assets/paypal-737290.svg";